module.exports = __webpack_public_path__ + "static/media/supportActive.ae507e3f.png";